module.exports = __webpack_public_path__ + "d-6IYplOFocCacKzxwXSOJBw1xU1rKptJj_0jans920.0b81348c81e06b7cb84c.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-google/d-6IYplOFocCacKzxwXSOJBw1xU1rKptJj_0jans920.woff2
// module id = ../../../../../src/assets/fonts/font-google/d-6IYplOFocCacKzxwXSOJBw1xU1rKptJj_0jans920.woff2
// module chunks = 40